import {createApp, h} from 'vue';
import {createPinia} from 'pinia';


import '../bootstrap';
import App from '@/WebApp/App.vue';
import router from "./router";
import {VueReCaptcha} from "vue-recaptcha-v3";
import * as Sentry from "@sentry/vue";

const env = import.meta.env;
const app = createApp({
	render: () => h(App),
	data() {
		return {}
	},
});

app.use(createPinia());
app.use(router);
//@ts-ignore
app.use(VueReCaptcha, {siteKey: env.VITE_RECAPTCHAV3_SITEKEY});

if (env.VITE_MIX === 'production') {
	Sentry.init({
		app: app,
		dsn: env.VITE_SENTRY_DSN_PUBLIC,
		integrations: [
			Sentry.browserTracingIntegration({router}),
		],
		tracePropagationTargets: ["localhost", env.VITE_MAIN_DOMAIN, env.VITE_ADMIN_DOMAIN, /^\//],
		tracesSampleRate: 1.0,
	});
	app.mixin(Sentry.createTracingMixins({hooks: [], timeout: 0, trackComponents: true}));
	Sentry.attachErrorHandler(app, {attachErrorHandler: true, attachProps: true});
}

app.mount('#app');

